import LegalTextHomeDirectDebit from './LegalTextHomeDirectDebit';

export default LegalTextHomeDirectDebit;
